import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Check, ArrowLeft } from "lucide-react";
import Header from "../components/Header";
import PromoBanner from "../components/PromoBanner";
import { useT } from "../lib/i18n";

export default function Success() {
    const { t } = useT();
    return (
        <div className="min-h-[100dvh] text-ink-primary relative overflow-hidden" data-testid="success-page">
            <Header />
            <PromoBanner />
            <div className="absolute inset-0 pointer-events-none">
                <div className="absolute inset-0 bg-[radial-gradient(60%_45%_at_50%_40%,rgba(212,175,55,0.16),transparent_70%)]" />
            </div>
            <main className="relative max-w-2xl mx-auto px-6 pt-40 pb-24 text-center">
                <motion.div
                    initial={{ scale: 0.6, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                    className="mx-auto w-24 h-24 rounded-full border border-gold/40 flex items-center justify-center animate-glow"
                >
                    <Check size={36} className="text-gold" strokeWidth={1.4} />
                </motion.div>

                <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3, duration: 0.7 }} className="mt-10">
                    <div className="label-eyebrow">{t("success.eyebrow")}</div>
                    <h1 className="font-serif font-medium text-5xl md:text-6xl mt-4 text-balance">
                        {t("success.title")}
                    </h1>
                    <p className="text-ink-secondary mt-6 text-lg max-w-md mx-auto leading-relaxed">{t("success.body")}</p>
                    <p className="text-ink-muted text-sm mt-6 max-w-md mx-auto leading-relaxed">{t("success.tip")}</p>

                    <Link
                        to="/"
                        data-testid="back-home"
                        className="mt-12 inline-flex items-center gap-2 text-gold text-sm tracking-[0.22em] uppercase hover:text-gold-bright transition-colors"
                    >
                        <ArrowLeft size={16} />
                        {t("success.cta")}
                    </Link>
                </motion.div>
            </main>
        </div>
    );
}
